var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":_vm.fieldName,"vid":_vm.metaName,"rules":_vm.validRules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var classes = ref.classes;
var errors = ref.errors;
return [_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:({
          content: errors[0],
          trigger: 'hover',
          show: errors[0],
        }),expression:"{\n          content: errors[0],\n          trigger: 'hover',\n          show: errors[0],\n        }",modifiers:{"bottom":true}}]},[_c('span',{staticClass:"valid-wrap",class:classes},[_vm._t("default")],2)])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }